import { apiSlice } from '../../api/apiSlice';

export const activityApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getActivitiesByFilter: builder.mutation({
      query: (options) => {
        return {
          url: `FlashCard/Paged/${options.skip}/${options.take}?${options.params.toString()}`,
          method: 'GET',
          credentials: 'include'
        };
      }
    }),
    isActivitiesExist: builder.mutation({
      query: () => ({
        url: 'FlashCard/UserHasFlashCard',
        method: 'GET',
        credentials: 'include'
      }),
      extraOptions: { showGlobalError: true }
    }),
    createActivity: builder.mutation({
      query: (option) => ({
        url: 'FlashCard/Create',
        method: 'POST',
        body: { ...option }
      }),
      extraOptions: { showGlobalError: true }
    }),
    shareFlashcards: builder.mutation({
      query: (options) => ({
        url: 'FlashCard/Share',
        method: 'POST',
        credentials: 'include',
        body: options
      }),
      extraOptions: { showGlobalError: true }
    }),
    assignFlashCardToStudents: builder.mutation({
      query: (options) => ({
        url: 'FlashCard/AssignToStudents',
        method: 'POST',
        credentials: 'include',
        body: options
      })
    }),
    deleteFlashcards: builder.mutation({
      query: (body) => ({
        url: 'FlashCard/Delete',
        method: 'DELETE',
        credentials: 'include',
        body
      }),
      extraOptions: { showGlobalError: true }
    }),
    moveActivitiesToFolder: builder.mutation({
      query: (options) => ({
        url: 'FlashCard/MoveToFolder',
        method: 'POST',
        credentials: 'include',
        body: options
      }),
      extraOptions: { showGlobalError: true }
    }),
    exportActivities: builder.mutation({
      query: (options) => ({
        url: 'FlashCard/ExportToXml',
        method: 'POST',
        credentials: 'include',
        body: options,
        responseHandler: (response) => response.blob(),
      }),
      extraOptions: { showGlobalError: true }
    }),
    publishActivity: builder.mutation({
      query: (options) => ({
        url: 'FlashCard/Publish',
        method: 'POST',
        body: {
          id : options.id,
          name: options.name,
          options: options.option
        }
      }),
      extraOptions: { showGlobalError: true }
    }),
    replaceActivity: builder.mutation({
      query: (options) => ({
        url: 'FlashCard/Replace',
        method: 'POST',
        body: {
          id : options.id,
          name: options.name,
          options: options.option
        }
      }),
      extraOptions: { showGlobalError: true }
    }),
    duplicateActivity: builder.mutation({
      query: (options) => ({
        url: 'FlashCard/Duplicate',
        method: 'POST',
        body: options.assignmentIds
      }),
      extraOptions: { showGlobalError: true }
    }),
    validatePublish: builder.mutation({
      query: (options) => ({
        url: 'FlashCard/ValidatePublish',
        method: 'GET',
        credentials: 'include',
        params: {
          id: options.id
        }
      }),
      extraOptions: { showGlobalError: true }
    }),
    getPreviewActivityInfo: builder.mutation({
      query: (option) => ({
        url: `FlashCard/${option.assignmentId}/DetailsById`,
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    }),
    moveVocabulary: builder.mutation({
      query: (option) => ({
        url: `FlashCard/${option.assignmentId}/MoveVocabulary`,
        method: 'PUT',
        params: {
          currentPosition: option.currentPosition,
          newPosition: option.newPosition
        }
      }),
      extraOptions: { showGlobalError: true }
    }),
    reorderVocabulary: builder.mutation({
      query: (option) => ({
        url: `FlashCard/${option.assignmentId}/ReorderVocabulary`,
        method: 'PUT'
      }),
      extraOptions: { showGlobalError: true }
    }),
    removeVocabulary: builder.mutation({
      query: (option) => ({
        url: `FlashCard/${option.assignmentId}/Vocabulary/${option.vocabularyNo}`,
        method: 'DELETE'
      }),
      extraOptions: { showGlobalError: true }
    }),
    ReclassifyFlashcardCourse: builder.mutation({
      query: (option) => ({
        url: `FlashCard/${option.id}/ReclassifyCourse?courseId=${option.courseId}`,
        method: 'POST'
      }),
      extraOptions: { showGlobalError: true }
    }),
    RenameFlashcard: builder.mutation({
      query: (option) => ({
        url: `FlashCard/${option.id}/Rename?flashcardName=${option.flashcardName}`,
        method: 'PUT'
      }),
      extraOptions: { showGlobalError: true }
    }),
    UpdateFlashcardTeacherNote: builder.mutation({
      query: (option) => ({
        url: `FlashCard/${option.id}/Note?note=${option.note}`,
        method: 'PUT'
      }),
      extraOptions: { showGlobalError: true }
    }),
    getFlashcardChangeReport: builder.mutation({
      query: (options) => ({
        url: `FlashCard/${options.id}/ChangeReport`,
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    }),
    validateFlashcardName: builder.mutation({
      query: (params) => ({
        url: 'FlashCard/ValidateFlashcardName',
        method: 'GET',
        credentials: 'include',
        params: params
      })
    }),
    getAllDropdownFlashcards: builder.mutation({
      query: () => ({
        url: 'Flashcard/for-dropdown',
        method: 'GET',
        credentials: 'include'
      })
    }),
    assignStudentsInFlashcard: builder.mutation({
      query: (options) => ({
        url: 'FlashCard/assign-students',
        method: 'POST',
        body: options
      })
    }),
  })
});

export const {
  useGetActivitiesByFilterMutation,
  useIsActivitiesExistMutation,
  useCreateActivityMutation,
  useShareFlashcardsMutation,
  useAssignFlashCardToStudentsMutation,
  useDeleteFlashcardsMutation,
  useExportActivitiesMutation,
  useMoveActivitiesToFolderMutation,
  usePublishActivityMutation,
  useReplaceActivityMutation,
  useDuplicateActivityMutation,
  useValidatePublishMutation,
  useGetPreviewActivityInfoMutation,
  useMoveVocabularyMutation,
  useReorderVocabularyMutation,
  useRemoveVocabularyMutation,
  useReclassifyFlashcardCourseMutation,
  useRenameFlashcardMutation,
  useUpdateFlashcardTeacherNoteMutation,
  useGetFlashcardChangeReportMutation,
  useValidateFlashcardNameMutation,
  useGetAllDropdownFlashcardsMutation,
  useAssignStudentsInFlashcardMutation
} = activityApi;
